import React, { useState ,useEffect} from 'react';
import { Container, Row, Col, Form } from "react-bootstrap";
import InputField from "../InputField/InputField";
import * as Yup from "yup";
import {useNavigate} from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { Formik } from "formik";
import { Flip, Slide, toast } from 'react-toastify';
import { userLogIn } from "../../services/auth";
import './Signup.styles.css';
import * as AuthVerify from '../../lib/common';
import Axios from '../../lib/axios/axiosInstance';

import { Link } from "react-router-dom";

const Signup = () => {
  const navigate = useNavigate();

  const logInFormHandler = async (values, url) => {
    const val = {
      username: values.email.toLowerCase(),
      password: values.passWord
    }
    const response = await userLogIn(val, url);
    if (response && response.status == 200) {

      await AuthVerify.setSession(response.data).then(async result=>{
        await Axios.get(`/cart/activecarth?username=${response.data.email}&arnum=${response.data.arnum}`)
        .then(async (refnum) => {
          if (refnum?.data && refnum.status == 200) {
            response.data.refnum=refnum.data.refnum;
            response.data.cartChanged=true;
          }
        });
        if(response.data.applycorpsetting){
          response.data.ccacNotNotified=true;
        }
        AuthVerify.setSession(response.data);
        AuthVerify.setPermissions();
        toast.success('Log In Successful', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
          transition: Slide,
        });
        navigate('/')
      })
    }
    else {
      toast.error('Email or Password is Invalid', {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
        transition: Flip,
      })
    }
  }

  useEffect(() => { 
    if(AuthVerify.isUserLogedIn()){
      navigate('/');
    }
	},[])

  const [initialValue, setInitialValue] = useState({
    email: "",
  });
  return (
      <Container className="main-new">
        <Row className='justify-content-center'>
          <Col xs={12} sm={12} lg={12}>
          <div className="jtv-menu-block-wrapper-new custom-menu">
          <div className="header-nav-dropdown-wrapper">
            <Col md={6} style={{display: "none"}}>
            <div className="jtv-custom-box-new">
              <i className="fa fa-user"></i><br></br>
              <Link
                to="/individual-sign-up"
                className="heading"
              >
                Individual Account
              </Link>
              {/* <p>Log in to enjoy member savings and earn rebates.</p> */}
                  <p style={{ paddingBottom: "22px" }} />
              <Formik
                initialValues={{
                  email: "",
                  passWord: "",
                }}
                validationSchema={Yup.object().shape({
                  email: Yup.string()
                    .required("Username is required"),
                  passWord: Yup.string().required(
                    "Password is required"
                  ),
                })}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                  const url = 'accounts/authenticate'
                  logInFormHandler(values, url);
                  // console.log("Logging in", values);
                  //alert(JSON.stringify(values, null, 4));
                  setSubmitting(false);
                  resetForm();
                }}
              >
                {(props) => {
                  const {
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    isSubmitting,
                    handleSubmit,
                  } = props;
                  return (
                    <Form onSubmit={handleSubmit}>
                      <ul className="form-list">
                        <li>
                          <InputField
                            Type="text"
                            Labels="Username"
                            Name="email"
                            value={values.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={!!errors.email}
                            className={"input-text required-entry" + (errors.email && touched.email) && 'is-invalid'}
                          //style={{ width: "200px" }}
                          />
                        </li>
                        <li>
                          <InputField
                            Type="password"
                            Labels="Password"
                            Name="passWord"
                            value={values.passWord}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={!!errors.passWord}
                            className={"input-text required-entry validate-password" + (errors.passWord && touched.passWord) && 'is-invalid'}
                          //style={{ width: "200px" }}
                          />
                        </li>
                      </ul>
                      <button
                        id="send2"
                        name="send"
                        type="submit"
                        disabled={isSubmitting}
                        className="button login"
                      >
                        <span>Log In</span>
                      </button><br></br>
                      <Link to="/forgot-password" className="forgot-word">
                        Forgot Your Password?
                      </Link>
                    </Form>
                  );
                }}
              </Formik>
              <hr />

              <h4 className="heading">Register Here</h4>
              <p>
                By creating an account with our store, you will be able
                to move through the checkout process faster, store
                multiple shipping addresses, view and track your orders
                in your account and more.
              </p>
              <Link to="/individual-sign-up">
                <button
                  className="button btn-cart"
                  type="button"
                  title=""
                  data-original-title="Add to Cart"
                >
                  <span>Individual Sign Up</span>
                </button>
              </Link>
              <p></p>
            </div>
            </Col>
            <Col md={4}/>
            <Col md={4}>
            <div className="jtv-custom-box-new">
              <i className="fa fa-briefcase"></i>
              <Link
                to="/corporate-sign-up"
                className="heading"
                style={{ padding: "0" }}
              ><br></br>
                Corporate Account
              </Link>
              <p>
                Log in to enjoy corporate discount and exclusive
                privileges.
              </p>
              <Formik
                initialValues={{
                  email: "",
                  passWord: "",
                }}
                validationSchema={Yup.object().shape({
                  email: Yup.string()
                    .required("Username is required"),
                  passWord: Yup.string().required(
                    "Password is required"
                  ),
                })}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                  const url = "accounts/authenticate"
                  logInFormHandler(values, url)
                  //alert(JSON.stringify(values, null, 4));
                  setSubmitting(false);
                  resetForm();
                }}
              >
                {(props) => {
                  const {
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                  } = props;
                  return (
                    <Form onSubmit={handleSubmit}>
                      <ul className="form-list">
                        <li>
                          <InputField
                            Type="text"
                            Labels="Username"
                            Name="email"
                            value={values.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={!!errors.email}
                            className={"input-text required-entry" + (errors.email && touched.email) && 'is-invalid'}
                          //style={{ width: "200px" }}
                          />
                        </li>
                        <li>
                          <InputField
                            Type="password"
                            Labels="Password"
                            Name="passWord"
                            value={values.passWord}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={!!errors.passWord}
                            className={"input-text required-entry validate-password" + (errors.passWord && touched.passWord) && 'is-invalid'}
                          //style={{ width: "200px" }}
                          />
                        </li>
                      </ul>
                      <button
                        id="send2"
                        name="send"
                        type="submit"
                        disabled={isSubmitting}
                        className="button login"
                      >
                        <span>Log In</span>
                      </button><br></br>
                      <Link to="/forgot-password" className="forgot-word">
                        Forgot Your Password?
                      </Link>
                    </Form>
                  );
                }}
              </Formik>
              <hr />
              <h4 className="heading">Register Here</h4>
              <p>
                <a href="/contactus">Contact us</a> to register for an account.
              </p>
              {/* <p>
                By creating an account with our store, you will be able
                to move through the checkout process faster, store
                multiple shipping addresses, view and track your orders
                in your account and more.
              </p>
              <Link to="/corporate-sign-up">
                <button
                  className="button btn-cart"
                  type="button"
                  title=""
                  data-original-title="Add to Cart"
                >
                  <span>Corporate Sign Up</span>
                </button>
              </Link> */}
              <p></p>
            </div>
            </Col>
            <Col md={4}/>
            {/* <Col md={4}>
            <div className="jtv-custom-box-new">
              <i className="fa fa-building"></i>
              <Link
                to="/partner-sign-up"
                className="heading"
                style={{ padding: "0" }}
              ><br></br>
                Partner Account
              </Link>
              <p>
                Log in to enjoy partner access and account management.
              </p>
              <Formik
                initialValues={{
                  email: "",
                  passWord: "",
                }}
                validationSchema={Yup.object().shape({
                  email: Yup.string()
                    .email("Email is invalid")
                    .required("Email is required"),
                  passWord: Yup.string().required(
                    "Password is required"
                  ),
                })}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                  const url = "accounts/authenticate"
                  logInFormHandler(values, url);
                  // console.log("Logging in", values);
                  //alert(JSON.stringify(values, null, 4));
                  setSubmitting(false);
                  resetForm();
                }}
              >
                {(props) => {
                  const {
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                  } = props;
                  return (
                    <Form onSubmit={handleSubmit}>
                      <ul className="form-list">
                        <li>
                          <InputField
                            Type="email"
                            Labels="Email Address"
                            Name="email"
                            value={values.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={!!errors.email}
                            className={"input-text required-entry" + (errors.email && touched.email) && 'is-invalid'}
                          //style={{ width: "200px" }}
                          />
                        </li>
                        <li>
                          <InputField
                            Type="password"
                            Labels="Password"
                            Name="passWord"
                            value={values.passWord}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={!!errors.passWord}
                            className={"input-text required-entry validate-password" + (errors.passWord && touched.passWord) && 'is-invalid'}
                          //style={{ width: "200px" }}
                          />
                        </li>
                      </ul>
                      <button
                        id="send2"
                        name="send"
                        type="submit"
                        disabled={isSubmitting}
                        className="button login"
                      >
                        <span>Log In</span>
                      </button><br></br>
                      <Link to="/forgot-password" className="forgot-word">
                        Forgot Your Password?
                      </Link>
                    </Form>
                  );
                }}
              </Formik>
              <hr />
              <h4 className="heading">Register Here</h4>
              <p>
                By creating an account with our store, you will be able
                to move through the checkout process faster, store
                multiple shipping addresses, view and track your orders
                in your account and more.
              </p>
              <Link to="/partner-sign-up">
                <button
                  className="button btn-cart"
                  type="button"
                  title=""
                  data-original-title="Add to Cart"
                >
                  <span>Partner Sign Up</span>
                </button>
              </Link>
              <p></p>
            </div>
            </Col> */}
          </div>
      </div>
          </Col>
        </Row>
      </Container>
  );
};

export default Signup;
